<template>
  <el-badge is-dot :hidden="hasfilter">
    <el-button type="info" plain @click="dialog = true">Filtrar</el-button>
      <el-drawer
      title="Filtro de Auditoria"
      :visible.sync="dialog"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawer"
      size="50%"
      :wrapperClosable="false"
      :append-to-body="true"
      :modal-append-to-body="false"
      :modal="true"
    >
      <div class="demo-drawer__content" style="padding: 10px">
        <el-form :model="filter" label-position="top" size="mini">
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="Objeto">
                <el-input v-model="filter.tag" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Arquivados">
                <el-radio-group v-model="filter.archived">
                  <el-radio label="1">Sim</el-radio>
                  <el-radio label="0">Não</el-radio>
                  <el-radio label="2">Ambos</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="$emit('close')">Cancelar</el-button>
          <el-button
            type="info"
            @click="
              $refs.drawer.closeDrawer();
              clear();
            "
            >Limpar filtros</el-button
          >
          <el-button
            type="primary"
            @click="
              $refs.drawer.closeDrawer();
              execute();
            "
            >Filtrar</el-button
          >
        </div>
      </div>
    </el-drawer>
    </el-badge>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      filter: {
        tag: "",
        archived: "0",
      },
    }
  },
  computed: {
    hasfilter() {
      const vm = this;
      return !(
        vm.filter.tag ||
        vm.filter.archived !== "0"
      );
    },
  },
  methods: {
    get() {
      return this.filter;
    },
    open() {
      const vm = this;
      vm.dialog = true;
    },
    close() {
      const vm = this;
      vm.dialog = false;
    },
    execute() {
      const vm = this;
      vm.$emit("filter");
      vm.dialog = false;
    },
    clear() {
      const vm = this;
      vm.filter.tag = "";
      vm.filter.archived = "0";
    },
  }
}
</script>